/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/*@ngInject*/
export default function CustomerDetailsController(userService, customerService) {

    var vm = this;

    vm.$onInit = function () {
        loadCustomer();
    };

    function loadCustomer() {
        customerService.getCustomer(userService.getCurrentUser().customerId).then(
            (customer) => {
                vm.customer = customer;
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/customer/customer-details.controller.js